import type { RoundContext } from '@/lib/games/engine/types';
import { grossToPar } from '@/lib/games/engine/helpers';

export function quotaTarget(handicap: number | null): number {
  const hcp = handicap ?? 18;
  return Math.max(10, 36 - Math.round(hcp));
}

export function computeQuota(ctx: RoundContext): {
  rows: Array<{ playerKey: string; name: string; quota: number; score: number; over: number }>;
  totals: Record<string, number>;
} {
  const totals: Record<string, number> = {};
  const rows = ctx.players.map((p) => {
    const quota = quotaTarget(p.handicap);
    const netToPar = grossToPar(ctx, p.playerKey, true);
    const gross = ctx.scores[p.playerKey] || [];
    const score = gross.filter((s) => s != null).reduce((a, b) => a + (b as number), 0);
    const over = netToPar != null ? quota + netToPar : 0;
    totals[p.playerKey] = over;
    return { playerKey: p.playerKey, name: p.name, quota, score, over };
  }).sort((a, b) => b.over - a.over);

  return { rows, totals };
}
